export const SET_ORGANIZATIONAL_STRUCTURES =
  "ORGANIZATIONAL_STRUCTURES/SET_ORGANIZATIONAL_STRUCTURES";
export const SET_STRUCTURE_ITEM =
  "ORGANIZATIONAL_STRUCTURES/SET_STRUCTURE_ITEM";
export const SET_TREE_STRUCTURE =
  "ORGANIZATIONAL_STRUCTURES/SET_TREE_STRUCTURE";
export const SET_PAGINATION = "ORGANIZATIONAL_STRUCTURES/SET_PAGINATION";
